import React from 'react';
import { useSelector } from 'react-redux';
import classCardImg from '../../../../../../assets/scoreboard/classCardImg.png';
import ScoreboardHeaderItem from '../../ScoreboardHeaderItem/ScoreboardHeaderItem';

const ClassHeaderItem = ({ item, onClick, onMouseEnter, onMouseLeave, isActive,number }) => {
 
  const {texts} = useSelector((state) => state.translate);


  return (
    <ScoreboardHeaderItem
      image={classCardImg}
      number={number?.classKey != null ? `${texts[number?.classKey] ?? ''}${number?.ordinal ?? ''}` : (number?.value != null ? number.value : texts[number?.key])}
      textKey={item.textKey}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      isActive={isActive}
    />
  );
};

export default ClassHeaderItem;
